export default "__VITE_ASSET__DbfYcs0a__"